module.exports = __webpack_public_path__ + "static/img/none.001db5ac.png";